var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 10H10C9.45 10 9 9.55 9 9C9 8.45 9.45 8 10 8H13C13 8 16 4.65625 16 3C16 1.34375 14.6562 0 13 0C11.3438 0 10 1.34375 10 3C10 3.79688 10.6937 4.98125 11.4156 6H10C8.34688 6 7 7.34688 7 9C7 10.6531 8.34688 12 10 12H13C13.55 12 14 12.45 14 13C14 13.55 13.55 14 13 14H5.79688C5.29688 14.775 4.74062 15.4906 4.31875 16H13C14.6531 16 16 14.6531 16 13C16 11.3469 14.6531 10 13 10ZM13 2C13.5531 2 14 2.44688 14 3C14 3.55312 13.5531 4 13 4C12.4469 4 12 3.55312 12 3C12 2.44688 12.4469 2 13 2ZM3 8C1.34375 8 0 9.34375 0 11C0 12.6562 3 16 3 16C3 16 6 12.6562 6 11C6 9.34375 4.65625 8 3 8ZM3 12C2.44688 12 2 11.5531 2 11C2 10.4469 2.44688 10 3 10C3.55312 10 4 10.4469 4 11C4 11.5531 3.55312 12 3 12Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.b77da9d841eb86648569690176cd0031.svg";
export { ForwardRef as ReactComponent };